var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckSquareOutline = function SvgCheckSquareOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.293 6.374A1 1 0 0 1 20 8.081l-9.252 9.252a2 2 0 0 1-2.829 0L4 13.414A1 1 0 0 1 5.414 12l3.919 3.919 9.253-9.252a1 1 0 0 1 .707-.293"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 0a5.007 5.007 0 0 1 5 5v14a5.007 5.007 0 0 1-5 5H5a5.007 5.007 0 0 1-5-5V5a5.007 5.007 0 0 1 5-5zM5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckSquareOutline;